import React, { useRef } from 'react';
import FiveStarRateImage from '../assets/images/5-star-rating.png';

import TestimonyOneImage from '../assets/images/testimoni-1.png';
import TestimonyTwoImage from '../assets/images/testimoni-2.png';

import testi1 from '../assets/images/testimonies/1.jpg';
import testi2 from '../assets/images/testimonies/2.jpg';
import testi3 from '../assets/images/testimonies/3.jpg';
import testi4 from '../assets/images/testimonies/4.jpg';
import testi5 from '../assets/images/testimonies/5.jpg';
import testi6 from '../assets/images/testimonies/6.jpg';
import testi7 from '../assets/images/testimonies/7.jpg';

import Carousel from 'react-tiny-slider';
import InstagramCTA from '../components/InstagramCTA';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  // faMedal,
  faArrowLeft,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';

const Testimony = () => {
  const carousel = useRef(null);
  const testimonyImages = [
    testi1,
    testi2,
    testi3,
    testi4,
    testi5,
    testi6,
    testi7,
  ];

  return (
    <section className='pt-12 primary-bg'>
      {/* <h2
        className='text-center font-bold text-3xl mb-6'
        style={{ fontFamily: 'Poppins' }}>
        Testimoni
        <FontAwesomeIcon icon={faMedal} className='ml-3' />
      </h2> */}

      <div className='w-4/5 mx-auto'>
        <img loading='lazy' className='w-100' src={FiveStarRateImage} alt='' />
      </div>

      <div>
        <Carousel
          swipeAngle={true}
          items={1}
          mouseDrag={true}
          ref={carousel}
          loop={true}
          controlsContainer='.slider-control'>
          {testimonyImages.map((testi) => {
            return (
              <div key={testi}>
                <img
                  loading='lazy'
                  src={testi}
                  alt='testimony'
                  className='w-100'
                />
              </div>
            );
          })}
        </Carousel>
        <div className='slider-control flex justify-center text-white mt-3'>
          <button className='secondary-bg px-3 py-1 mr-2 rounded-md'>
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
          <button className='secondary-bg px-3 py-1 rounded-md'>
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
        </div>
      </div>

      <div className='flex justify-around mt-12'>
        <div className='w-11/12'>
          <img
            loading='lazy'
            src={TestimonyOneImage}
            className='w-100'
            alt=''></img>
        </div>
        <div className='w-11/12'>
          <img
            loading='lazy'
            src={TestimonyTwoImage}
            className='w-100'
            alt=''></img>
        </div>
      </div>

      <div className='pb-12 pt-8 border-b border-gray-400 w-11/12 mx-auto'>
        <InstagramCTA />
      </div>
    </section>
  );
};

export default Testimony;
